﻿module.exports = {
    "id": "sc",
    "label": "Simplified Chinese",
    "rtl": false,

    "translations": {
        "INVALID_LINK_TITLE": "无效链接",
        "INVALID_LINK_TEXT": "请点击邮件内的取消订阅链接,将您的电邮从我们的列表中移除。",
        "UNSUBSCRIBE_ARE_YOU_SURE": "您确定要把您的电邮地址从我们的列表中移除？",
        "UNSUBSCRIBE_CLICK_CONFIRM": "点击\"取消订阅\"按钮以示确认。",
        "YOU_HAVE_BEEN_UNSUBSCRIBED": "您已<b>取消订阅</b>。",
        "UNSUBSCRIBED_IN_ERROR": "如果您误点了取消订阅，请点击 <a href='/resubscribe' class='resubscribe'>重新订阅</a>。",
        "CANCELLED_STILL_SUBSCRIBED": "<b>已取消。</b>\" 您依旧<b>订阅</b>我们的电邮。",
        "THANK_YOU_FOR_CONTINUING": "感谢您继续参与我们的调查。",
        "EMAIL_ALREADY_UNSUBSCRIBED": "该电邮已<b>取消订阅</b>。",
        "CLICK_RESUBSCRIBE_TO_REJOIN": "点击下方\"重新订阅\"按钮再次加入我们的电邮列表。",
        "YOU_HAVE_BEEN_RESUBSCRIBED": "您已<b>重新订阅</b>我们的电邮列表。",
        "YOU_ARE_ALREADY_SUBSCRIBED": "您已<b>订阅</b>我们的电邮列表。",
        "THANK_YOU_FOR_PARTICIPATING": "感谢您参与我们的调查。",
        "CHECKING": "核对中...",
        "UNSUBSCRIBE": "取消订阅",
        "RESUBSCRIBE": "重新订阅",
        "EMAIL": "电件",
        "CANCEL": "取消"
    }
};

